/** de_mirage → Mirage; plain names title-cased lightly. */
export function formatMapName(map: string | null | undefined): string {
  const raw = (map ?? '').trim();
  if (!raw) return '';
  const withoutPrefix = raw.replace(/^de_/i, '');
  return withoutPrefix
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/** full_buy → Full buy */
export function formatBuyType(buyType: string | null | undefined): string {
  if (!buyType) return '';
  return buyType
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase());
}

/** Short scoreboard label from a team name (up to 4 uppercase letters). */
export function teamShortName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return 'TEAM';
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return words
      .slice(0, 4)
      .map((w) => w[0])
      .join('')
      .toUpperCase();
  }
  return trimmed.slice(0, 4).toUpperCase();
}

/** Initials from a display name (1–2 chars). */
export function initials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '??';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
